export default "__VITE_ASSET__BHxvvsuf__"